import React, { useContext, useEffect, useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AuthContext } from 'components/user/AuthContext';
import Action from './Action';
import api from 'lib/api';

const Like = ({ twutId, currentUserLiked, initialLikesCount }) => {
  const { isLoggedIn } = useContext(AuthContext);
  const [likesCount, setLikesCount] = useState(initialLikesCount);
  const [liked, setLiked] = useState(currentUserLiked);
  const [isAnimating, setIsAnimating] = useState(false);
  const queryClient = useQueryClient();

  useEffect(() => {
    setLiked(isLoggedIn ? currentUserLiked : false);
    setLikesCount(initialLikesCount);
  }, [currentUserLiked, initialLikesCount, isLoggedIn]);

  const { mutate } = useMutation({
    mutationFn: () => api.twut.toggleLike(twutId),
    onMutate: () => {
      setLiked((prevLiked) => !prevLiked);
      setLikesCount((prevCount) => liked ? prevCount - 1 : prevCount + 1);
      setIsAnimating(true);
      setTimeout(() => { setIsAnimating(false); }, 500);

      return { previousLiked: liked, previousCount: likesCount };
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['twuts']);
    },
    onError: (error, variables, context) => {
      setLiked(context.previousLiked);
      setLikesCount(context.previousCount);
    },
  });

  const handleLikeToggle = () => {
    if (isLoggedIn) { mutate(); }
  };

  return (
    <Action
      count={likesCount}
      onClick={handleLikeToggle}
      disabled={!isLoggedIn}
      ariaLabel={liked ? "Unlike" : "Like"}
      tooltipPrefix="Total Likes: "
      buttonClassName={`${isLoggedIn ? 'cursor-pointer' : 'cursor-default'} ${!liked && 'text-gray-more'} ${!liked && isLoggedIn && 'hover:text-red-mid'}`}
      iconClassName={`fa-heart transition-transform duration-200 ease-in-out ${liked ? 'fa-solid text-red-more' : 'fa-regular'} ${isAnimating ? 'animate-ping' : ''}`}
      countClassName={liked && 'text-red-more'}
    />
  );
};

export default Like;
